import { FC } from 'react'

import MaskedInput from 'antd-mask-input'

type Props = { mask: string }

export const MaskInput: FC<Props> = ({ mask, ...otherProps }) => (
  <MaskedInput mask={mask} {...otherProps} />
)
